export const UserData = `
id
roles {
  id
  name
  isActive
  permissions{
    app
    permissions
  }
}
email
isActive
requiredMfa
mfaEnrolledAt
lastLoggedInAt
firebaseId
firstName
middleName
lastName
displayName
phoneNo
address
avatarUrl
username
gender
dob
`;
